
export class Toast {
    constructor(
        public id: string,
        public messages: string[],
        public type: ToastType = ToastType.Error,
    ) {}

    public get isSuccess() {
        return this.type === ToastType.Success;
    }

    public get isError() {
        return this.type === ToastType.Error;
    }

    public get isWarning() {
        return this.type === ToastType.Warning;
    }

    public get isInfo() {
        return this.type === ToastType.Info;
    }
}

export enum ToastType {
    Success = 'SUCCESS',
    Error = 'ERROR',
    Info = 'INFO',
    Warning = 'WARNING',
}
